<template>
    <div class="custom-search" :class="{ 'disable': disable }">
        <input
            type="text"
            :value="value"
            :placeholder="placeholder"
            :disable="disable"
            @input="search($event)"
        >

        <svg viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg" class="icon">
            <g>
                <title>background</title>
                <rect x="-1" y="-1" width="48" height="48" fill="none"/>
            </g>
            <g>
                <title>Layer 1</title>
                <path d="m44.498 44.415c-1.6691 1.6691-4.3745 1.6691-6.0438 0l-7.5415-7.5416c-3.1005 1.989-6.7655 3.1741-10.723 3.1741-11.012 0-19.941-8.9273-19.941-19.941s8.9285-19.941 19.941-19.941c11.014 0 19.941 8.927 19.941 19.941 0 3.9559-1.1866 7.6223-3.1742 10.724l7.5416 7.5416c1.6691 1.6691 1.6691 4.3731 0 6.0422zm-24.308-38.551c-7.8658 0-14.243 6.376-14.243 14.243s6.3775 14.243 14.243 14.243c7.8671 0 14.243-6.3761 14.243-14.243s-6.3761-14.243-14.243-14.243z" fill="#d0d0df" stroke="null"/>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: ''
		},

		placeholder: {
			type: String,
			default: ''
		},

		disable: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		search (event) {
			if (this.disable) return

			clearTimeout(this.searchTimeout)

			this.searchTimeout = setTimeout(() => {
				this.$emit('input', event.target.value)
			}, 500)
		}
	}
}
</script>

<style lang="scss" scoped>

.custom-search {
    position: relative;
    width: 300px;

    input {
        border: 1px solid #D0D0DF;
        border-radius: 5px;
        padding: 5px 30px 5px 10px;
        font-size: 1em;
        height: 2.3em;
        width: 100%;
        line-height: 37px;
        transition: 0.3s;

        &::placeholder {
            color: #777;
        }

        &:focus {
            outline: none;
            border-color: #2DC4B6;
        }
    }

    .icon {
        position: absolute;
        height: 50%;
        right: .5em;
        top: 25%;
    }

    &.disable {
        input {
            background: #f5f5f5;
        }
    }
}
</style>
